export default "__VITE_ASSET__q7rEFN9p__"